import{CertificateTemplateType as e}from"../api/models/certificate-template.js";const o=t=>t?(typeof t=="object"?t.type:t)===e.Custom:!0;export{o as isTemplateCustomType};
//# sourceMappingURL=certificates.js.map
